import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/footer.css"; // Importar archivo de estilo CSS

const Footer = () => {
  return (
    <div className="container-fluid">
      <footer className="bg-dark text-white py-5 mb-0">
        <Container>
          <Row className="text-center text-md-start align-items-center">
            {/* Columna 1: Logo y Nombre */}
            <Col xs={12} md={4} className="text-center text-md-center mb-4 mb-md-0">
              <img src="/assets/dist/img/logo.png" alt="Logo" className="mb-3" width="120" />
              <p className="mb-1 fw-bold">Morena Mia</p>
              <p className="mb-1">Tienda de Café</p>
              <p>Bogotá, Colombia</p>
            </Col>

            {/* Columna 2: Información de contacto */}
            <Col xs={12} md={4} className="text-center text-md-start mb-4 mb-md-0">
              <h5 className="fw-bold">Información de Contacto</h5>
              <p className="mb-1"> Teléfono: (+57) 321 423 00 46</p>
              <p className="mb-1"> Email: morenamiacs@gmail.com</p>
              <p>Dirección: Cra. 109A #142 97, Parque Lombardia, Suba, Bogotá</p>
              {/* Icono de Instagram */}
              <a href="https://www.instagram.com/morenamiacafebog/" className="text-white fw-bold">
                <i className="fab fa-instagram me-2 "></i>@MORENAMIACAFEBOG
              </a>
            </Col>

            {/* Columna 3: Espacio para agregar enlaces futuros */}
            <Col xs={12} md={4} className="text-center text-md-start mb-5">
              <h5 className="fw-bold">Enlaces</h5>
              <ul className="list-unstyled">
                <li>
                  <a  href="#inicio" className="text-white text-decoration-none">Inicio</a>
                </li>
                <li>
                  <a  href="#inicio" className="text-white text-decoration-none">Productos</a>
                </li>
                <li>
                  <a  href="#inicio" className="text-white text-decoration-none">Contáctanos</a>
                </li>
              </ul>
            </Col>
          </Row>

          {/* Derechos reservados */}
          <Row className="mt-4">
            <Col className="text-center">
              <p className="m-0">© 2024 Morena Mia. Todos los derechos reservados.</p>
              <p className="m-0">Diseñado por Creatas Digital | Contacto: <a href="mailto:soportesoftware67@gmail.com" className="text-white text-decoration-none">soportesoftware67@gmail.com</a></p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Footer;
